import * as React from 'react';
import { connect } from 'react-redux';

import CcmCampaignPaymentsEmptyPayouts from './empty/CcmCampaignPaymentsEmptyPayouts';
import CcmCampaignPaymentsWithDataPayouts from './with-data/CcmCampaignPaymentsWithDataPayouts';

import { Subcampaign } from 'types';

interface StateProps {
  subcampaigns: Array<Subcampaign>
}

type Props = StateProps;

const CcmCampaignPaymentsPayouts = ({ subcampaigns }: Props) => (
  <div className="ccm-campaign-payments-payouts">
    {subcampaigns.length === 0 ? (
      <CcmCampaignPaymentsEmptyPayouts />
    ) : (
      <CcmCampaignPaymentsWithDataPayouts subcampaigns={subcampaigns} />
    )}
  </div>
);

const mapStateToProps = ({ campaignSubcampaigns }): StateProps => ({
  subcampaigns: campaignSubcampaigns.list
});


export default connect(mapStateToProps)(CcmCampaignPaymentsPayouts);
